<template>
<div class="cigo-layer-loading">
    <cigo-icon-font class="loading-icon" name="cigoadmin-icon-jiazai"></cigo-icon-font>
    <span class="tips">{{msg}}</span>
</div>
</template>

<script lang="ts">
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    defineComponent,
    toRef
} from "vue";

export default defineComponent({
    name: "CigoLayerLoading",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props) {
        let msg = toRef(props.layerData, "msg");
        return {
            msg
        };
    }
});
</script>

<style lang="scss">
.cigo-layer-loading {
    width: auto;
    height: 61px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 12px 20px;
    border: 1px solid #f0f0f0;

    .loading-icon {
        width: 35px;
        height: 35px;
        margin-right: 20px;

        -webkit-animation: playBTN 1.5s infinite linear;
        animation: playBTN 1.5s infinite linear;
    }

    @-webkit-keyframes playBTN {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(358deg);
            transform: rotate(358deg);
        }
    }

    @keyframes playBTN {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(358deg);
            transform: rotate(358deg);
        }
    }

    .tips {
        color: #666;
        font-size: 14px;
    }
}
</style>
